import { CompetitionResultsDatatable } from '../components/datatables/competitionResultsDatatable';

const Competitions = () => {
    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 xl:grid-cols-2 items-center'>
                    <div>
                        <h1 className='font-medium text-2xl'>Tävlingsresultat</h1>
                        <p className='text-muted-foreground text-sm'>Här visas alla tidigare tävlingsresultat.</p>
                    </div>
                    {/* {isLoading ? (
                    <p>Loading...</p>
                ) : (
                    <ul className='w-5/6'>
                        {competitions.map(competition => (
                            <CompetitionItem competition={competition} />
                        ))}
                    </ul>
                )} */}
                </div>
                <CompetitionResultsDatatable />

            </div>
        </div>
    );
};

export default Competitions;